module.exports = __webpack_public_path__ + "33b7edf3ac188da68dd108e0442da38e.png";